export type DemoAdPlacement = {
  id: string
  title: string
  subtitle: string
  cta: string
  href: string
  imageUrl?: string
  imageUrl2x?: string
  imageWidth?: number
  imageHeight?: number
  imageAlt?: string
  variant?: 'text' | 'image' | 'placeholder'
}

/** Сквозной рекламный слот на всех страницах маркета */
export const globalDemoAd: DemoAdPlacement = {
  id: 'ad-placeholder',
  title: 'Место для вашей рекламы',
  subtitle: 'marketing@provisium.ru',
  cta: '',
  href: 'mailto:marketing@provisium.ru',
  variant: 'placeholder',
}

export const getDemoAdForRoute = (): DemoAdPlacement => globalDemoAd
